export const paths = {
	home: `/`,

	/* Auth routes */
	login: `/login`,
	magicLinkVerification: `/sign-in`,
	notFound: `/not-found`,

	/* Search and filters routes */
	search: `/search`,
	searchHcp: `/search/hcp`,
	searchHco: `/search/hco`,
	hcp: `/hcp/:hcpId`,
	hco: `/hco/:hcoId`,
	hcoAffiliatedHCPs: `/hco/:hcoId/affiliated-HCPs`,

	/* DCRs */
	dcrs: `/my-dcrs`,

	wildcard: '*'
};
